import type { Scene } from './types';

// The back end (docs/BACKEND.md). A share is an immutable version; versions belong to a porch, and the edit key for
// this browser's porch lives in localStorage. An emailed link gives another browser a key of its own.

async function call<T>(method: string, url: string, body?: unknown, key?: string): Promise<T> {
  const headers: Record<string, string> = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  // as a bearer token: Caddy's access log redacts Authorization, where it kept a custom header whole (#85)
  if (key) headers.Authorization = `Bearer ${key}`;
  const r = await fetch(url, { method, headers, body: body === undefined ? undefined : JSON.stringify(body), credentials: 'same-origin' });
  const text = await r.text();
  let data: unknown = null;
  try { data = text ? JSON.parse(text) : null; } catch { throw new Error(`server said ${r.status}`); }
  if (!r.ok) throw new Error((data as { error?: string })?.error ?? `server said ${r.status}`);
  return data as T;
}

export interface Mine { porch: string; key: string }
const MINE = 'pumpkin.porch';
export function mine(): Mine | null {
  try { const m = JSON.parse(localStorage.getItem(MINE) ?? 'null'); return m?.porch && m?.key ? m : null; } catch { return null; }
}
export const setMine = (m: Mine | null) => (m ? localStorage.setItem(MINE, JSON.stringify(m)) : localStorage.removeItem(MINE));

export interface Version { id: string; porch: string; scene: Scene; message: string; name?: string; created: number; mine: boolean }

/** a new version of this browser's porch (or a new porch); its link never changes after */
export async function share(scene: Scene, message: string, name = ''): Promise<{ id: string; url: string; porch: string }> {
  const m = mine();
  const r = await call<{ id: string; url: string; porch: string; editKey?: string }>('POST', '/api/share.php', { scene, message, name, porch: m?.porch }, m?.key);
  if (r.editKey) setMine({ porch: r.porch, key: r.editKey });
  return r;
}


export const loadVersion = (id: string) => call<Version>('GET', `/api/share.php?id=${encodeURIComponent(id)}`, undefined, mine()?.key);
/** links from before versions: read only */
export const loadOld = (id: string) => call<{ id: string; title: string | null; scene: Scene }>('GET', `/api/scene.php?id=${encodeURIComponent(id)}`);
export const latest = (m: Mine) => call<{ porch: string; id: string; scene: Scene; message: string; hasEmail: boolean }>('GET', `/api/porch.php?id=${encodeURIComponent(m.porch)}`, undefined, m.key);

export const requestEdit = (id: string, email: string) => call<{ ok: boolean; devLink?: string }>('POST', '/api/email.php?a=request', { id, email });
export async function redeem(porch: string, token: string): Promise<Mine> {
  const r = await call<{ editKey: string }>('POST', '/api/email.php?a=redeem', { porch, token });
  const m = { porch, key: r.editKey };
  setMine(m);
  return m;
}
export const reportBug = (b: { message: string; email: string; page: string; info: string; website: string }) => call<{ ok: boolean }>('POST', '/api/contact.php', b);
